import { render } from "./Services.vue?vue&type=template&id=2cf94ccc"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
script.render = render

export default script